import { api } from './api';
import axios from 'axios';

export async function getVirtualGoods() {
  try {
    const { data } = await api.get('virtualgoods/item?player=me&orderby=extra.order&reverse=false');
    return data;
  } catch (error) {
    return error;
  }
}

export async function getExperienceCatalog() {
  try {
    const { data } = await api.get('database/experiencias__c');
    return data;
  } catch (error) {
    return error;
  }
}

export async function getVirtualGood(_id: string) {
  try {
    const { data } = await api.get(`virtualgoods/item/${_id}`);
    return data;
  } catch (error) {
    return error;
  }
}

export async function purchaseItem(item: string, player: string) {
  try {
    const { data } = await api.post('virtualgoods/purchase', {
      item,
      player,
    });
    return data;
  } catch (error) {
    return error;
  }
}

export async function getStore(player: string) {
  try {
    const { data } = await api.post(`find/store`, {
      player
    });

    if (Array.isArray(data)) {
      return data[0];
    }
    return data;
  } catch (error) {
    return error;
  }
}

export async function getPurchase(player: string, item: string) {
  try {
    const { data } = await api.post(`find/purchases`, {
      player,
      item
    });

    return data;
  } catch (error) {
    return error;
  }
}

export async function getCouponStatus(couponId: string) {
  try {
    const { data } = await api.post(`find/coupons`, {
      _id: couponId
    });
    return data;
  } catch (error) {
    return error;
  }
}

export async function getRewardStatus(playerId: string, rewardId: string) {
  try {
    const body = [
      {
        "$match": {
          "parent": "salonpatinesmusic"
        }
      },
      {
        "$group": {
          "_id": null,
          "items": {
            "$push": "$_id"
          }
        }
      },
      {
        "$lookup": {
          "from": "achievement",
          "let": {
            "items": "$items"
          },
          "pipeline": [
            {
              "$match": {
                "$expr": {
                  "$in": [
                    "$item",
                    "$$items"
                  ]
                }
              }
            }
          ],
          "as": "purchases"
        }
      },
      {
        "$unwind": "$purchases"
      },
      {
        "$replaceRoot": {
          "newRoot": "$purchases"
        }
      },
      {
        "$lookup": {
          "from": "player",
          "localField": "player",
          "foreignField": "_id",
          "as": "player"
        }
      },
      {
        "$unwind": "$player"
      },
      {
        "$lookup": {
          "from": "catalog_item",
          "localField": "item",
          "foreignField": "_id",
          "as": "item"
        }
      },
      {
        "$unwind": "$item"
      },
      {
        "$lookup": {
          "from": "rewards_log__c",
          "localField": "_id",
          "foreignField": "_id",
          "as": "redeem"
        }
      },
      {
        "$unwind": {
          "path": "$redeem",
          "preserveNullAndEmptyArrays": true
        }
      },
      {
        "$match": {
          "player._id": playerId, // Filtrar pelo ID do jogador
          "_id": rewardId // Filtrar pelo ID da recompensa/compra
        }
      },
      {
        "$sort": {
          "time": -1
        }
      }
    ];

    const auth = {
      username: '64c683bcc27bff1439b74e95',
      password: '63c9b676d3182407ddefdb2c'
    };

    const response = await axios.post(
      'https://service2.funifier.com/v3/database/rewards__c/aggregate',
      body,
      {
        auth: auth
      }
     );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar status da recompensa:", error);
    return null;
  }
}
